import { theme } from '@features/lci-report/domain/theme';
import { contentSlideHeader } from '@features/lci-report/utils/slide-header';
import { Slide, composeSlides } from '@features/powerpoint';
import { TITLE } from '../../shared/dark-background-slide-master';
import { chart, stepBox } from './components';

type LciAdaptiveSyntheticControlSlideProps = {
  firstStepText: string;
};

const baseSlide = (props: LciAdaptiveSyntheticControlSlideProps): Slide => ({
  slideMaster: TITLE,
  texts: [
    contentSlideHeader('LCI Adaptive Synthetic Control', {
      color: theme.colors.white,
    }),
    {
      text: 'Fueled by real-time, real-world data, for real-time decision making',
      options: {
        bold: true,
        color: theme.colors.inmarketGreen,
        h: 0.4,
        w: 10,
        x: 0.77,
        y: 1.62,
      },
    },
    stepBox('Step 1', props.firstStepText, { x: 1, y: 2.38, h: 1.6, w: 2.7 }),
    stepBox(
      'Step 2',
      'Exposure is measured against the control to determine lift.',
      { x: 3.95, y: 2.38, h: 1.17, w: 2.7 }
    ),
    stepBox(
      'Step 3',
      'Real-time data is used to validate the control against market trends and recalibrates based on real-time signals.',
      { x: 9.18, y: 4.89, h: 1.4, w: 3.38 }
    ),
  ],
});

export const lciAdaptiveSyntheticControlSlide = (
  props: LciAdaptiveSyntheticControlSlideProps
): Slide => composeSlides(baseSlide(props), chart);
